export default "__VITE_ASSET__Df3umgK1__"